// src/pages/ThemeCreate.jsx
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { collection, getDocs, addDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';
import schoolTheme from '../themes/schoolFuturisticTheme.json';

export default function ThemeCreate() {
  const { themeId } = useParams();
  const navigate = useNavigate();
  const [creating, setCreating] = useState(false);

  async function handleCreate() {
    const user = auth.currentUser;
    if (!user) {
      alert('Please sign in to create a site.');
      return;
    }

    const uid = user.uid;
    const colRef = collection(db, `users/${uid}/sites`);
    const snap = await getDocs(colRef);
    if (snap.size >= 2) {
      alert('You can create only 2 websites.');
      return;
    }

    setCreating(true);
    try {
      const theme = themeId === schoolTheme.themeId ? schoolTheme : schoolTheme;
      const payload = {
        title: `${theme.themeName} - ${uid.slice(0,6)}`,
        themeId: theme.themeId,
        themeVars: theme.themeVars,
        site: theme.site,
        createdAt: new Date().toISOString(),
        owner: uid
      };
      const docRef = await addDoc(colRef, payload);
      // open editor on default page (home)
      navigate(`/builder/${docRef.id}/home`);
    } catch (err) {
      console.error(err);
      alert('Failed to create site: ' + err.message);
    } finally {
      setCreating(false);
    }
  }

  return (
    <div style={{ padding: 24 }}>
      <h2>Create site from theme</h2>
      <p>Theme: {schoolTheme.themeName}</p>
      <button onClick={handleCreate} disabled={creating}>
        {creating ? 'Creating…' : 'Create site (max 2 allowed)'}
      </button>
    </div>
  );
}
